<template>
	<div class="o-dashboard" v-if="user">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/gebruikersbeheer">Gebruikersbeheer</a>
				</li>
				<li>
					<span>{{user.name}}</span>
				</li>
			</ul>
		</div>

       <div class="o-dashboard__panels">
			<div class="row collapse">
				<div class="column small-12 xlarge-8">
					<c-block-user-info :user="user"></c-block-user-info>
				</div>
			</div>
		</div>

        <c-edit-user-settings
            v-show="modalEditUserSettings"
            @close="modalEditUserSettings = false"
			@added="load"
            :size="'medium'"
            :editUser="user">
        </c-edit-user-settings>

		<c-remove
			text="2FA"
			removeText="Resetten"
			v-show="modalRemove"
			@close="modalRemove = false"
            @remove="disable2FA()"
			:size="'tiny'">
		</c-remove>

	</div>
</template>

<script>
import Form from '@mixins/Form';
import CBlockUserInfo from '@components/blocks/UserInfo';
import CEditUserSettings from '@app/modals/EditUserSettings';
import CRemove from '@app/modals/Remove';

export default {
	mixins: [ Form ],
    components: {CBlockUserInfo, CEditUserSettings, CRemove},
	data() {
		return {
			user: '',
            modalEditUserSettings: false,
			modalRemove: false
		}
	},
    methods: {
        openModalEditUserSettings() {
			this.modalEditUserSettings = true;
		},
		openModalDisable2FA() {
			this.modalRemove = true;
		},	
		load(){
			this.$xhr.get('/api/users/' + this.$route.params.id ).then( ({result}) => {
				this.user = result;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Gebruikergegevens kunnen niet worden ingeladen'});
			});
		},
		disable2FA(){
			this.$xhr.post('/api/' + this.user.id + '/disable-2fa' ).then( ({result}) => {
				this.$store.dispatch('toast/success', {title: '2FA uitgeschakeld', text: '2FA is uitgeschakeld'});
				this.modalRemove = false;
				this.load();
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: '2FA kon niet worden uitgeschakeld'});
			});
		}
    },
    created() {
		this.$store.dispatch('listener/on', {
			listener: this.openModalEditUserSettings,
			event: 'change-user',

		});
		this.$store.dispatch('listener/on', {
			listener: this.openModalDisable2FA,
			event: 'remove-2fa',

		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/on', {
			listener: this.openModalEditUserSettings,
			event: 'change-user',
		});
		this.$store.dispatch('listener/on', {
			listener: this.openModalDisable2FA,
			event: 'remove-2fa',
		});
	},

	mounted(){
		this.load();
	}
}
</script>
